// extracted by mini-css-extract-plugin
export default {"container":"OurSpace_component_container__Pgand","wrapper":"OurSpace_component_wrapper__mLZtF","infoCopy":"OurSpace_component_infoCopy__4pXf+"};